/* CreateSocialLinks.js */

import React from 'react';
import { useHistory } from 'react-router-dom';
import Footer1 from '../../components/commom/Footer1';
import SocialLinksForm from '../../components/remix/SocialLinksForm';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

export default function CreateSocialLinks() {
  const history = useHistory();

  const callBackAfterCreation = () =>  history.push('/dashboard');
  
  return (
    <>
      <AppBar2 />

      <SocialLinksForm openTinyPageAfterCreation={true} callBackAfterCreation={callBackAfterCreation} createMode />

      <Footer1 />
    </>
  );
}
